"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelectCheckbox = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react = _interopRequireWildcard(require("react"));
var _spacing = require("../../../../constants/spacing");
var _checkbox = require("../../../checkbox");
const noopClickHandler = () => {
  // Nothing here intentionally - the Checkbox is purely presentational.
  // Its state is controlled by its parents.
};
const MultiSelectCheckboxStyled = /*#__PURE__*/(0, _react.memo)((0, _styled.default)(_checkbox.Checkbox)`
    margin-right: ${_spacing.sizes.xSmall}px;
    vertical-align: middle;
`);
const MultiSelectCheckbox = props => {
  return /*#__PURE__*/_react.default.createElement(MultiSelectCheckboxStyled, (0, _extends2.default)({
    "aria-hidden": true,
    omitHiddenInput: true
  }, props, {
    tabIndex: -1,
    onClick: noopClickHandler
  }));
};
exports.MultiSelectCheckbox = MultiSelectCheckbox;
//# sourceMappingURL=MultiSelectCheckbox.js.map